const EnvironmentVariableConstants = {
    VITE_API_URL: 'VITE_API_URL',
    VITE_API_CONSUMER_KEY: 'VITE_API_CONSUMER_KEY',
    VITE_API_CONSUMER_SECRET: 'VITE_API_CONSUMER_SECRET',
    VITE_API_BASE_URL: 'VITE_API_BASE_URL',
    VITE_API_CORE_PATH: 'VITE_API_CORE_PATH',
    VITE_API_APP_PATH: 'VITE_API_APP_PATH',
    VITE_ASSETS_URL: 'VITE_ASSETS_URL',
    VITE_API_PATH_URL: 'VITE_API_PATH_URL',
    VITE_API_CUSTOM_PATH_URL: 'VITE_API_CUSTOM_PATH_URL',
    VITE_CURRENCY: 'VITE_CURRENCY',
    VITE_APP_NAME: 'VITE_APP_NAME',
    VITE_APP_SECRET_KEY: 'VITE_APP_SECRET_KEY',
    VITE_MOCKED_DATA: 'VITE_MOCKED_DATA',
};

export default EnvironmentVariableConstants;
